import React, { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

import { focusFirstInvalidField } from './focus-first-invalid-field.helpers';

interface IFocusFirstInvalidFieldProps {
  formId: string;
}

// Renderless: on a failed submit (one that leaves validation errors), focus the
// first invalid field. Must render inside the Formik tree to read submitCount/errors.
export const FocusFirstInvalidField: React.FC<IFocusFirstInvalidFieldProps> = ({ formId }) => {
  const { submitCount, errors, isValidating, isSubmitting } = useFormikContext();
  const lastHandledSubmit = useRef(0);

  useEffect(() => {
    // Formik settles a failed submit over several renders (isValidating, then
    // errors, then isSubmitting); only once isSubmitting clears are errors final.
    if (submitCount === lastHandledSubmit.current || isValidating || isSubmitting) return;
    lastHandledSubmit.current = submitCount;

    const errorNames = Object.keys(errors);
    if (!errorNames.length) return;

    const formEl = document.getElementById(formId);
    if (formEl) focusFirstInvalidField(formEl, errorNames);
  }, [submitCount, isValidating, isSubmitting, errors, formId]);

  return null;
};
